import React from "react";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Card } from "../../../../components/card";
import SurveyQuestionPreviewCard from "./SurveyQuestionPreviewCard";
import { getSurveyQuestionTypes } from "../../data";
import type { SurveyQuestion } from "../../types/survey.types";

interface QuestionPreviewProps {
  questions: SurveyQuestion[];
}

export function QuestionPreview({ questions }: QuestionPreviewProps) {
  const { t } = useTranslation();
  const questionTypes = getSurveyQuestionTypes(t);

  return (
    <Card
      className={`bg-white dark:bg-gray-800 shadow-sm border border-gray-200 dark:border-gray-700 rounded-xl flex flex-col ${questions.length === 0 ? "h-auto" : "h-[800px]"}`}
    >
      <div className="p-6 flex-shrink-0">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">Questions</h3>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <div className="p-6">
          {questions.length === 0 ? (
            <div className="text-center py-8 border-gray-300 dark:border-gray-600 rounded-lg dark:bg-gray-700/50">
              <div className="text-gray-400 dark:text-gray-500">
                <div className="flex justify-center mb-3">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: "#F3F4F6" }}
                  >
                    <Plus className="h-8 w-8 opacity-50" />
                  </div>
                </div>
                <p className="text-sm font-semibold">No questions yet</p>
                <p className="text-xs mt-1">Click "Add Question" to get started</p>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              {questions.map((question, index) => (
                <SurveyQuestionPreviewCard
                  key={question.client_id ?? `question-${question.position ?? index}`}
                  question={question}
                  index={index}
                  questionTypeLabel={
                    questionTypes.find((type) => type.value === question.type)?.label
                  }
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}

export default QuestionPreview;
